import React from "react";
import "./styles.css";
import Modal from "react-bootstrap/Modal";

const ModalContainer = (props) => {
  const customStyle = props.width ? { width: props.width } : { width: "100%" };

  return (
    <Modal
      size={props.size}
      show={props.show}
      onHide={props.handleClose}
      // dialogClassName="modal-100w"
      // dialogClassName="custom-modal"
    >
      {props.title && (
        <Modal.Header closeButton>
          <Modal.Title className="modal_title">{props.title}</Modal.Title>
        </Modal.Header>
      )}
      <div style={customStyle}>{props.children}</div>
    </Modal>
  );
};

export default ModalContainer;
